export const columnsDataInvoices = [
  {
    Header: "System ID",
    accessor: "invoiceNumber",
  },
  {
    Header: "Invoice Number",
    accessor: "referenceNumber",
  },
  {
    Header: "Debtor Name",
    accessor: "debtorName",
  },
  {
    Header: "Invoice Amount",
    accessor: "amount",
  },
  {
    Header: "Funded Amount",
    accessor: "fundedAmount",
  },
  {
    Header: "Collected Amount",
    accessor: "collectedAmount",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Expected Due Date",
    accessor: "expectedDueDate",
  },
  {
    Header: "Actions",
    accessor: "actions",
  },
];
